// src/components/home/Notifications.js
import React, { useState, useEffect } from "react";
import { useAtom } from "jotai";
import moment from "moment";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import {
    appConstants,
    activeChildDetail,
    NotificationAtom
} from "../../atomstore/store";
import { fetchChildTimeline } from "../../queryfunctions/queryfunctions";
import { useRequestProcessor } from "../../requestProcessor";
import UpdateCard from "../home/UpdateCard";
import SpinnerLoading from "./SpinnerLoading";

const ITEM_PER_PAGE = 50;

const Notifications = ({ setSelectedPhoto }) => {
    const navigate = useNavigate();

    const [ChildTimeline, setTimeline] = useAtom(NotificationAtom);
    const [constants] = useAtom(appConstants);
    const [activeChild] = useAtom(activeChildDetail);

    const [childTimeline, setChildTimeline] = useState({ startIndex: 0 });
    const [dataAvailable, setDataAvailable] = useState(true);
    const [length, setLength] = useState(0);

    const { useQueryWrapper } = useRequestProcessor();

    const { isLoading } = useQueryWrapper(
        ["NotificationsTimeline", activeChild?.id],
        () =>
            fetchChildTimeline(
                childTimeline.startIndex,
                setDataAvailable,
                ChildTimeline,
                ITEM_PER_PAGE,
                constants?.INCLUDE_TYPES_NOTIFICATION,
                setLength,
                setTimeline,
                null
            ),
        { keepPreviousData: true },
        {
            onSuccess: (data) => {
                if (!Array.isArray(data)) return;
                setChildTimeline(data);
            }
        }
    );

    console.log("child", ChildTimeline)
    // Flatten groups
    const flattenedUpdates = React.useMemo(() => {
        if (!Array.isArray(ChildTimeline)) return [];

        return ChildTimeline.flatMap(group =>
            (group?.data || []).map(item => ({
                ...item,
                dateGroup: group.dateGroup
            }))
        ).sort((a, b) => {
            // Combine date and time in ISO format for reliable sorting
            const d1 = new Date(`${a.dateGroup}T${a.time}`);
            const d2 = new Date(`${b.dateGroup}T${b.time}`);
            return d2 - d1; // descending: most recent first
        });
    }, [ChildTimeline]);

    const loadMore = () => {
        setChildTimeline(prev => ({
            ...prev,
            startIndex: (prev.startIndex || 0) + ITEM_PER_PAGE
        }));
    };

    return (
        <div className="fixed inset-0 bg-gray-50 z-50 overflow-y-auto">
            {isLoading && <SpinnerLoading />}
            {/* HEADER — same as TakeBreak */}
            <div className="sticky top-0 bg-white border-b p-4 flex items-center space-x-3">
                <button onClick={() => navigate(-1)}>
                    <ChevronLeft className="w-6 h-6 text-gray-600" />
                </button>
                <h2 className="text-lg font-bold text-gray-800 cursor-pointer" onClick={() => navigate(-1)}>Notifications</h2>
            </div>

            <div className="p-4 space-y-4">
                {flattenedUpdates.length === 0 ? (
                    <div className="bg-gray-50 rounded-xl p-6 text-center text-gray-600">
                        No updates available
                    </div>
                ) : (
                    <div className="space-y-4">
                        {flattenedUpdates.map((update, idx) => (
                            <UpdateCard
                                key={idx}
                                update={update}
                                setSelectedPhoto={setSelectedPhoto}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Notifications;
